import AutoComplete from 'autocomplete-js';

class BaseAutocomplete
{
    /**
     * @param {Element} element
     */
    constructor(element) {
        this.container = element;
        this.searchInput = element.querySelector('[data-search="input"]');
        this.submitButton = element.querySelector('[data-search="submit"]');

        this.initListeners();
    }

    get minimumChars() {
        return 3;
    }

    initListeners() {
        AutoComplete({
            Url: this.searchInput.getAttribute('data-endpoint'),
            HttpMethod: 'POST',
            QueryArg: 'term',
            EmptyMessage: '',
            MinChars: this.minimumChars,
            _Post: (response) => {
                try {
                    let returnResponse = [];
                    let json = JSON.parse(response);

                    if (json.data.length === 0) {
                        return '';
                    }

                    Array.from(json.data).forEach((item) => returnResponse.push(this.formatOption(item)));

                    return returnResponse;
                } catch (event) {
                    return '';
                }
            },

            _Blur: this.blurCallback(),

            /**
             * @param {Element} item
             * @private
             */
            _Select: (item) => {
                this.select(item.getAttribute('data-autocomplete-value'));
            },
        }, this.searchInput);

        this.searchInput.addEventListener('keyup', (event) => {
            if(event.keyCode !== 13 || this.searchInput.hasAttribute('data-selected-value')) {
                return false;
            }

            this.submit();
        });

        if (this.submitButton) {
            this.submitButton.addEventListener('click', () => {
                this.submit();
            });
        }
    }

    select(value) {
        this.searchInput.setAttribute('data-selected-value', value);
        this.searchInput.value = value;
    }

    blurCallback() {
        return function () {
            setTimeout(() => this._Close(), 150);
        };
    }

    submit() {}

    /**
     * @param item
     * @return {{Value, Label: string}}
     */
    formatOption(item) {
        return {
            'Value': item,
            'Label': this.formatOptionTemplate(item),
        };
    }

    formatOptionTemplate(item) {
        return item;
    }
}

export {BaseAutocomplete};
